<div class="inbox-team home-section">
    <div class="title-section">
        <div class="inbox-marker"></div>
        <div class="div-label">
            <mat-label class="label-title">Bandejas del Equipo</mat-label>
            <a class="change-inbox" (click)="showInboxPersonal()">
                Cambiar a mi Bandeja
            </a>
        </div> 
    </div>
    <div class="search-section">
        <mat-form-field class="search-well-card dense-3">
            <mat-label class = "label-well">Buscá un pozo</mat-label>
            <input type="text" value={{textSearch}} aria-label="Well" 
            matInput #searchText (keyup.enter)="getHandoversHomeInboxTeamWithFilter(searchText.value)">
            <span matSuffix class="cursor-pointer" (click)="getHandoversHomeInboxTeamWithFilter(searchText.value)">
              <mat-icon class="material-icons-outlined" aria-hidden="false" aria-label="Account">search</mat-icon>
            </span>
        </mat-form-field> 
    </div>
    <div class="content-section">
        <div class="handovers" *ngIf="totalHandoversInboxTeam != 0">
            <app-handover-card *ngFor="let handover of handoversInboxTeam" [handover]="handover"
                (reload)="eventReload($event)">
            </app-handover-card>
        </div>
        <div class="empty-content" *ngIf="totalHandoversInboxTeam == 0">
            <div *ngIf="this.textSearch == ''">
                <p class="personal-empty">No hay Handovers aún</p>
                <p class="personal-empty-text">Cuando un miembro de tu equipo tome un Handover de la <br> Bandeja General, podrás visualizarlo acá</p>
            </div>
            <div *ngIf="this.textSearch != ''">
                <p class="personal-empty">No hay handovers para el filtro aplicado</p>
            </div>
        </div>
    </div>
</div>